import React from 'react';

function Footer() {
    return (
        <div >
            <p> &#xa9; 2024 - Hospital Management System - Developed by <span className='text-primary'>Vishnu Nair B </span> </p>
        </div>
    )
}

export default Footer